import React from "react";
import { Avatar, Badge, Tooltip } from "@material-ui/core";
import { BadgeOrigin } from "@material-ui/core/Badge/Badge";

import { SharedAvatarsType } from "../../constants/types";
import { IUser } from "../../types/user/iuser.interface";
import { withShowIf } from "../with-show-if/with-show-If.component";

import { CardAvatarLeftovers } from "./components/card-avatar-leftovers/card-avatar-leftovers.component";
import { SharedAvatarsProps } from "./shared-avatars.props";
import { useToolTipStyles } from "./shared-avatars.styles";

export const SharedAvatars = withShowIf((props: SharedAvatarsProps) => {
  const numberOfShowingImages = props.type === SharedAvatarsType.GRID_TYPE ? 4 : 3;
  const classes = useToolTipStyles();

  const hasLeftovers = () => props.people.length > numberOfShowingImages;

  const anchorOrigin: BadgeOrigin = {
    vertical: "bottom",
    horizontal: "right",
  };

  return (
    <div className="card-avatars">
      {props.people.slice(0, numberOfShowingImages).map((person: IUser, index: number) => (
        <Tooltip
          key={index}
          arrow
          classes={classes}
          placement="top"
          title={`${person.firstName} ${person.lastName}`}
        >
          <Badge
            anchorOrigin={anchorOrigin}
            color="primary"
            variant="dot"
            invisible={person.showBadge !== true}
          >
            <Avatar alt={`${person.firstName} ${person.lastName}`} src={(person.profileImageUrl) ? person.profileImageUrl : "/profile.png" } />
          </Badge>
        </Tooltip>
      ))}
      <CardAvatarLeftovers
        showIf={hasLeftovers()}
        leftovers={props.people.length - numberOfShowingImages}
      />
    </div>
  );
});
